// Lightweight platform detection with no external deps
// Treat Chrome on iOS as Safari (WebKit)

export const isNativePlatform = (): boolean => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cap = (globalThis as any)?.Capacitor;
    const fn = cap?.isNativePlatform as (() => boolean) | undefined;
    return typeof fn === 'function' ? fn() : false;
  } catch {
    return false;
  }
};

export const isIOSWeb = (): boolean => {
  if (isNativePlatform()) return false;
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  const iOSUA = /iPad|iPhone|iPod/.test(ua);
  const isIpadOS13Plus = navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1;
  return iOSUA || isIpadOS13Plus;
};

export const isIOSNative = (): boolean => {
  if (!isNativePlatform()) return false;
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cap = (globalThis as any)?.Capacitor;
    const platform = typeof cap?.getPlatform === 'function' ? cap.getPlatform() : undefined;
    return platform === 'ios';
  } catch {
    return false;
  }
};

export const isAndroidWeb = (): boolean => {
  if (isNativePlatform()) return false;
  if (typeof navigator === 'undefined') return false;
  return /Android/.test(navigator.userAgent || '');
};

export const isDesktopWeb = (): boolean => {
  return !isNativePlatform() && !isIOSWeb() && !isAndroidWeb();
};
